import React from "react";

const AboutMissonAndVision = () => {
    return (
        <section className="about_mission_vision_section" id="vision&mission">
            <div className="container">
                <div className="our_mission_and_vision">
                    <div className="our_mission_section">
                        <div className="our_mission_title_section">
                            <h1 className="our_mission_title">Our Mission</h1>
                        </div>
                        <div className="our_mission_paragraph_section">
                            <p>Greeco Plast is committed to a future of excellence, driven by innovation and a dedication to our customers. We strive to produce the highest quality PVC Furniture Product solutions at competitive prices, while minimizing environmental impact through sustainable practices. We foster strong relationships with our partners and strive for continuous improvement to achieve global leadership in the industry.</p>
                        </div>
                    </div>
                    <div className="our_vision_section">
                        <div className="our_vision_title_section">
                            <h1 className="our_vision_title">Our Mission</h1>
                        </div>
                        <div className="our_vision_paragraph_section">
                            <p>Greeco Plast is dedicated to providing exceptional customer service and sustainable, high-quality PVC Furniture Product solutions. We strive to create a thriving and ethical workplace while minimizing our environmental impact. Our commitment to innovation drives us to develop eco-friendly and affordable product alternatives that enhance customer well-being and protect the planet. We aim to expand our market reach, build strong relationships with our customers, and deliver consistent excellence in all aspects of our business.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutMissonAndVision